import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

export async function moduleList(query?: any) {
	const queryString = formatQueryString(query);

	return await clientAxios.get(`module/list${queryString}`);
}

export async function moduleGet(module_id: string) {
	return await clientAxios.get(`module/${module_id}/show`);
}

export async function moduleCreate(payload: any) {
	return await clientAxios.post(`module/create`, payload);
}

export async function moduleUpdate(module_id: string, payload: any) {
	return await clientAxios.put(`module/${module_id}/update`, payload);
}

export async function modulePatch(module_id: string, payload: Partial<any>) {
	return await clientAxios.patch(`module/${module_id}/patch`, { payload });
}

export async function moduleDelete(module_id: string) {
	return await clientAxios.del(`module/${module_id}/delete`);
}
